module.exports = __webpack_public_path__ + "static/img/us-forces-stamp.48d9c76.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/graphics/us-forces-stamp.png
// module id = vId7
// module chunks = 1